module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2ZKSl"))).then(() => parcelRequire('2KbAe'));